"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayersOverview = exports.getCurrentPlayerIndex = void 0;
var vue_1 = require("vue");
var PlayerInfo_1 = require("./PlayerInfo");
var OverviewSettings_1 = require("./OverviewSettings");
var OtherPlayer_1 = require("../OtherPlayer");
var ActionLabel_1 = require("./ActionLabel");
var Phase_1 = require("../../Phase");
var SHOW_NEXT_LABEL_MIN = 2;
var getCurrentPlayerIndex = function (currentPlayerColor, players) {
    var currentPlayerIndex = 0;
    players.forEach(function (p, index) {
        if (p.color === currentPlayerColor) {
            currentPlayerIndex = index;
        }
    });
    return currentPlayerIndex;
};
exports.getCurrentPlayerIndex = getCurrentPlayerIndex;
exports.PlayersOverview = vue_1.default.component('players-overview', {
    props: {
        player: {
            type: Object,
        },
    },
    components: {
        'player-info': PlayerInfo_1.PlayerInfo,
        'overview-settings': OverviewSettings_1.OverviewSettings,
        'other-player': OtherPlayer_1.OtherPlayer,
    },
    data: function () {
        return {};
    },
    methods: {
        hasPlayers: function () {
            return this.player.players.length > 0;
        },
        getPlayerOnFocus: function () {
            var _this = this;
            return this.player.players.filter(function (p) { return p.color === _this.player.color; })[0];
        },
        getIsFirstForGen: function (player) {
            return exports.getCurrentPlayerIndex(player.color, this.player.players) === 0;
        },
        getPlayersInOrder: function () {
            var players = this.player.players;
            var result = [];
            var currentPlayerOffset = 0;
            var currentPlayerIndex = exports.getCurrentPlayerIndex(this.player.color, this.player.players);
            currentPlayerOffset = currentPlayerIndex + 1;
            result = players
                .slice(currentPlayerOffset)
                .concat(players.slice(0, currentPlayerOffset));
            return result.slice(0, -1);
        },
        getActionLabel: function (player) {
            var _this = this;
            if (this.player.game.phase === Phase_1.Phase.DRAFTING) {
                if (player.needsToDraft) {
                    return ActionLabel_1.ActionLabel.DRAFTING;
                }
                else {
                    return ActionLabel_1.ActionLabel.NONE;
                }
            }
            else if (this.player.game.phase === Phase_1.Phase.RESEARCH) {
                if (player.needsToResearch) {
                    return ActionLabel_1.ActionLabel.RESEARCHING;
                }
                else {
                    return ActionLabel_1.ActionLabel.NONE;
                }
            }
            if (this.player.game.passedPlayers.includes(player.color)) {
                return ActionLabel_1.ActionLabel.PASSED;
            }
            if (player.isActive)
                return ActionLabel_1.ActionLabel.ACTIVE;
            var notPassedPlayers = this.player.players.filter(function (p) { return !_this.player.game.passedPlayers.includes(p.color); });
            var currentPlayerIndex = exports.getCurrentPlayerIndex(player.color, notPassedPlayers);
            var prevPlayerIndex = currentPlayerIndex === 0 ?
                notPassedPlayers.length - 1 :
                currentPlayerIndex - 1;
            var isNext = notPassedPlayers[prevPlayerIndex].isActive;
            if (isNext && this.player.players.length > SHOW_NEXT_LABEL_MIN) {
                return ActionLabel_1.ActionLabel.NEXT;
            }
            return ActionLabel_1.ActionLabel.NONE;
        },
    },
    template: "\n        <div class=\"players-overview\" v-if=\"hasPlayers()\">\n            <overview-settings />\n            <div class=\"other_player\" v-if=\"player.players.length > 1\">\n                <div v-for=\"(otherPlayer, index) in getPlayersInOrder()\" :key=\"otherPlayer.id\">\n                    <other-player v-if=\"otherPlayer.id !== player.id\" :player=\"otherPlayer\" :playerIndex=\"index\"/>\n                </div>\n            </div>\n            <player-info v-for=\"(p, index) in getPlayersInOrder()\"\n              :activePlayer=\"player\"\n              :player=\"p\"\n              :key=\"p.id\"\n              :firstForGen=\"getIsFirstForGen(p)\"\n              :actionLabel=\"getActionLabel(p)\"\n              :playerIndex=\"index\"/>\n            <div v-if=\"player.players.length > 1\" class=\"player-divider\" />\n            <player-info\n              :player=\"getPlayerOnFocus()\"\n              :activePlayer=\"player\"\n              :key=\"player.players.length - 1\"\n              :firstForGen=\"getIsFirstForGen(player)\"\n              :actionLabel=\"getActionLabel(player)\"\n              :playerIndex=\"-1\"/>\n        </div>\n    ",
});
//# sourceMappingURL=PlayersOverview.js.map